var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374151",
    d: "M16.734 8A7.75 7.75 0 0 0 8.984.25 7.75 7.75 0 0 0 1.234 8a7.75 7.75 0 0 0 6.54 7.656V10.24h-1.97V8h1.97V6.293c0-1.943 1.156-3.016 2.927-3.016.848 0 1.735.152 1.735.152v1.906h-.978c-.962 0-1.263.598-1.263 1.21V8h2.15L12 10.24h-1.806v5.416A7.75 7.75 0 0 0 16.735 8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.984 0h16v16h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.984 0h16v16h-16z"
  })))));
};
export default SvgFacebook;